// extracted by mini-css-extract-plugin
export var typingIndicator = "_py-0";